import { Navigate, useParams } from 'react-router-dom';
import { crewWeekPath } from './links';

/**
 * `/time` and `/time/:projectId/:weekStart` (2026-09-18): the old weekly
 * sheet is no longer an entry screen, so its addresses — bookmarks, links in
 * old emails, anything still pointing there — land on Time Entry → Crew with
 * that job and week preselected. `replace`, so Back does not bounce.
 */
export function TimeIndexRedirect() {
  return <Navigate to={crewWeekPath()} replace />;
}

export function TimeSheetRedirect() {
  const { projectId, weekStart } = useParams();
  return <Navigate to={crewWeekPath(projectId, weekStart)} replace />;
}
